import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

const CreateCustomer = () => {
  const { t } = useTranslation();
  const [customer, setCustomer] = useState({
    name: "",
    shopName: "",
    mobile: "",
    email: "",
    address: "",
  });

  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!customer.name || !customer.shopName || !customer.mobile) {
      setError(t("customer_form.requiredFieldsError"));
      return;
    }

    try {
      await axios.post("http://localhost:5000/api/customers", customer);
      setSuccess(t("customer_form.successMessage"));
      setCustomer({ name: "", shopName: "", mobile: "", email: "", address: "" });
    } catch (err) {
      setError(t("customer_form.failureMessage"));
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-10 bg-white p-6 rounded shadow">
      <h2 className="text-2xl font-bold mb-6 text-center text-blue-600">
        {t("customer_form.createCustomer")}
      </h2>

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block mb-1">{t("customer_form.customerName")} *</label>
          <input
            type="text"
            name="name"
            value={customer.name}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded"
            placeholder={t("customer_form.enterCustomerName")}
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">{t("customer_form.shopName")} *</label>
          <input
            type="text"
            name="shopName"
            value={customer.shopName}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded"
            placeholder={t("customer_form.enterShopName")}
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">{t("customer_form.mobileNumber")} *</label>
          <input
            type="text"
            name="mobile"
            value={customer.mobile}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded"
            placeholder={t("customer_form.enterMobileNumber")}
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">{t("customer_form.email")}</label>
          <input
            type="email"
            name="email"
            value={customer.email}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded"
            placeholder={t("customer_form.enterEmailOptional")}
          />
        </div>

        <div className="mb-4">
          <label className="block mb-1">{t("customer_form.address")}</label>
          <textarea
            name="address"
            value={customer.address}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded"
            placeholder={t("customer_form.enterAddress")}
          ></textarea>
        </div>

        {error && <p className="text-red-500 mb-3">{error}</p>}
        {success && <p className="text-green-600 mb-3">{success}</p>}

        <button
          type="submit"
          className="w-full bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded"
        >
          {t("customer_form.saveCustomer")}
        </button>
      </form>
    </div>
  );
};

export default CreateCustomer;
